import React from "react"
import Layout from "../templates/layout"
import styled from "styled-components"
import { HiOutlineDesktopComputer } from "react-icons/hi"
import { FiDatabase } from "react-icons/fi"
import { MdKeyboardArrowRight } from "react-icons/md"
import Typical from "react-typical"
import { Helmet } from "react-helmet"
import Pdf from "../../static/curriculo.pdf"

export default function Home() {
  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Luidy Dias</title>
      </Helmet>
      <Me>
        <div />
        <h1>Luidy Dias</h1>
        <Typical
          steps={["Web Developer", 5000, "Full-Stack", 4000]}
          loop={Infinity}
          wrapper="h3"
        />
      </Me>
      <Container>
        <Text>
          <h1>Who am I?</h1>
          <p>
            I'm Luidy Dias, a Full-Stack Developer currently living in Bagé,
            Brazil. I started coding in mid 2 years ago and since then I never
            stopped it. I'm always looking for new knowledges and trying do my
            best every single line of coding.
          </p>
          <p>
            I've created this portfolio with purpose of showing a bit of  my
            work as a Full-Stack Developer.
          </p>
        </Text>
        <Expertise>
          <h5>Expertise in</h5>
          <span>
            <HiOutlineDesktopComputer className="icon" /> <div />
            Front-End
          </span>
          <span>
            <FiDatabase className="icon" /> <div />
            Back-End
          </span>
          {/* <span><FaMobileAlt className="icon"/> <div/>Mobile</span> */}
        </Expertise>
        <Expertise>
          <h5>Education</h5>
          <a
            href="http://intranet.ifsul.edu.br/catalogo/curso/4"
            target="_blank"
          >
            Técnico em Informática - IFSUL
          </a>
          <p>2017 - 2021</p>
        </Expertise>
        <ButtonCV href={Pdf} target="_blank">
          <Arrow className="icon">
            <div />
            <i class="arrow right" />
          </Arrow>
          See More
          <MdKeyboardArrowRight className="arrow" />
        </ButtonCV>
      </Container>
    </Layout>
  )
}

const Text = styled.div``

const Me = styled.div`
  height: 60vh;
  background: rgb(24, 24, 24);
  background-image: linear-gradient(
      90deg,
      rgba(24, 24, 24, 0.5519782913165266) 0%,
      rgba(32, 32, 32, 0.5959558823529411) 100%
    ),
    url("https://cdn.pixabay.com/photo/2016/05/24/16/48/mountains-1412683_960_720.png");
  background-size: cover;
  background-position: center;
  backdrop-filter: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: all 0.2s;

  div {
    background-image: url(${require("../images/luidy.jpg")});
    background-size: cover;
    background-position: center;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    margin: 0 auto;
    border: 4px solid white;
    transition: all 0.4s ease-out;
  }

  h1 {
    font-size: 42px;
    font-weight: 500;
    text-transform: uppercase;
    margin-top: 1rem;
    color: white;
  }

  h3 {
    font-weight: 400;
    margin-top: 0.5rem;
    color: white;
  }
`
const Arrow = styled.div`
  display: flex;
  align-items: center;

  div {
    width: 0rem;
    height: 2px;
    background-color: var(--color-primary);
    transition: all 0.4s;
  }
  .arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    border-color: var(--color-primary);
    opacity: 0;
    padding: 3px;
    transition: all 0.4s;
  }

  .right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
`

const ButtonCV = styled.a`
  margin-right: auto;
  display: flex;
  align-items: center;
  border-radius: 2px;
  text-transform: uppercase;
  text-decoration: none;

  color: var(--color-text-1);
  font-weight: 400;
  margin-top: 3rem;
  font-size: 18px;
  letter-spacing: 1px;

  .arrow {
    margin-left: -0.2rem;
    font-size: 22px;
    transition: all 0.2s;
  }

  &:hover {
    .icon {
      margin-right: 1rem;
      div {
        width: 3rem;
      }

      .arrow {
        opacity: 1;
      }
    }

    .arrow {
      opacity: 0;
    }
  }
`

const Expertise = styled.div`
  margin-top: 2rem;
  h5 {
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 1.5rem;
    font-style: italic;
    color: var(--color-text-1);
  }

  span,
  a {
    display: flex;
    align-items: center;
    color: var(--color-text-3);
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 0.8rem;
    transition: all 0.4s;

    &:hover {
      color: var(--color-text-1);
      div {
        width: 3rem;
      }
    }

    .icon {
      font-size: 20px;
      color: var(--color-text-3) !important;
    }

    div {
      width: 2rem;
      height: 2px;
      margin: 0 0.5rem;
      background-color: var(--color-text-3);
      transition: all 0.4s;
    }
  }

  p {
    font-size: 16px !important;
  }
`

const Container = styled.div`
  padding: 6rem 2rem;
  width: 50%;
  display: flex;
  flex-direction: column;
  padding-bottom: 10rem;
  transition: all 0.4s;

  @media (max-width: 1200px) {
    padding: 2rem 2rem;
  }

  @media (max-width: 1200px) {
    width: 80%;
  }

  h1 {
    font-weight: 500;
    font-size: 36px;
    color: var(--color-text-1);

    strong {
      font-weight: 500;
      font-size: 6vh;
      color: var(--color-text-3);
    }
  }

  p {
    color: var(--color-text-3);
    font-size: 19px;
    margin: 1rem 0;
  }
`
